import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  providers: []

})

export class ErrorComponent {

  isAltiumLoginError: boolean = false;
  params: any = {};

  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService, private router: Router) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params['error']) {
        this.isAltiumLoginError = true;
        this.params = params;
        this.authService.logOut();
      }
    });
  }

  ngOnInit() {
    if (!this.isAltiumLoginError) {
      this.router.navigate(['/page-not-found']);
    }
  }
}
